// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 955) return "static/chunks/955.80d614783cb406bc.js";
	if (chunkId === 1570) return "static/chunks/1570.604521d8b55df5d6.js";
	if (chunkId === 5170) return "static/chunks/5170.caeec56ea5f75c7d.js";
	if (chunkId === 9009) return "static/chunks/9009.bbc69585b731c733.js";
	if (chunkId === 7729) return "static/chunks/7729.41b3345882307103.js";
	if (chunkId === 3989) return "static/chunks/3989.78fa76377ebf7699.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3454":"lucide","4736":"vendor","5514":"react","8592":"common"}[chunkId] || chunkId) + "-" + {"3454":"2ec1dcb49f000300","4736":"eed48c109b1c8580","5264":"3c5f13388fcb1f58","5514":"59182b42e5c1ae90","6272":"30f4351d41434013","6321":"a9a6cc7e24cad17b","8592":"60fb3c06e36ede09"}[chunkId] + ".js";
};